import { Icon as CroplerIcon } from '@cropler/ui-kit';
import type { ComponentProps } from 'react';

type IconProps = Omit<ComponentProps<typeof CroplerIcon>, 'name'>;

export const IconNDVI = (props: IconProps) => <CroplerIcon name="crops" {...props} />;
export const IconT = (props: IconProps) => <CroplerIcon name="temperature" {...props} />;
export const IconChart = (props: IconProps) => <CroplerIcon name="chartBars" {...props} />;
export const IconWater = (props: IconProps) => <CroplerIcon name="water" {...props} />;
export const IconDew = (props: IconProps) => <CroplerIcon name="dew" {...props} />;
export const IconSortList = (props: IconProps) => <CroplerIcon name="sort" {...props} />;
export const IconBBCH = (props: IconProps) => <CroplerIcon name="stage" {...props} />;

// Sidebar
export const DashboardIcon = (props: IconProps) => <CroplerIcon name="dashboard" {...props} />;
export const MapsIcon = (props: IconProps) => <CroplerIcon name="mapMenu" {...props} />;
export const CropsIcon = (props: IconProps) => <CroplerIcon name="cropRotation" {...props} />;
export const ScoringIcon = (props: IconProps) => <CroplerIcon name="aiMenu" {...props} />;
export const FieldsIcon = (props: IconProps) => <CroplerIcon name="fields" {...props} />;
export const SettingsIcon = (props: IconProps) => <CroplerIcon name="cameraMenu" {...props} />;
export const TeamIcon = (props: IconProps) => <CroplerIcon name="team" {...props} />;
export const SoilIcon = (props: IconProps) => <CroplerIcon name="plant" {...props} />;